module.exports = __webpack_public_path__ + "img/hr-diesel-locomotive-14.830d032b.png";